import React, { Component } from 'react';
import {Table, Icon} from "antd";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { deleteDocument} from "../redux/actions/Firebase";
import { getDocumentInfo } from "../redux/actions/Stations";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

class StationsList extends Component{
  state = {
    columns: [
      {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
        align: 'center',
      },
      {
        title: 'Fecha',
        dataIndex: 'date',
        key: 'date',
        align: 'center',
      },
      {
          title: "Acciones",
          key: "name_doc_id",
          dataIndex: "name_doc_id",
          render: id => (
            <div>
                <Icon style={{marginRight: 5, marginLeft: 5}} type="eye" onClick={() => this.handleView(id)}/>
                <Icon style={{marginRight: 5, marginLeft: 5}} type="edit" onClick={() => this.handleEdit(id)}/>
                <Icon style={{marginRight: 5, marginLeft: 5}} type="delete" onClick={() => this.confirm(id)}/>
            </div>
          ),
          align: 'center',
      }
    ]
  }

  handleDelete = (name) => {
    this.props.deleteDocument(name);
  }

  confirm = (name) => {
    confirmAlert({
      title: 'Confirmar para borrar',
      message: '¿Está seguro de que desea borrar esta estación?',
      buttons: [
        {
          label: 'Sí',
          onClick: ()=>this.handleDelete(name)
        },
        {
          label: 'No'
        }
      ]
    });
  };

  handleEdit = (doc_name_id) => {
    this.props.getDocumentInfo(doc_name_id)
    this.props.history.push("/editStation")
  }

  handleView = (doc_name_id) => {
    this.props.getDocumentInfo(doc_name_id)
    this.props.history.push("/viewStation")
  }

  render(){
    return(
        <div style={{paddingTop: 50}}>
            <Table
              dataSource={this.props.stations}
              columns={this.state.columns}
              rowKey="id"
              pagination={{
                style: { flex: 1, width: '100%', marginTop: 25, textAlign: 'center' }
              }}
            />
        </div>
    )
  }
}

const mapStateToProps = state => {
  return { stations: state.stations.data,
          firebase: state.firebase
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators({deleteDocument, getDocumentInfo}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(StationsList)
